import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import api from "./api";
import { devWarn } from "./dev-log";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // The httpOnly cookie (if present) is sent automatically; we ask the server who we are.
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    setUser({ ...data.user, role: "consultant" });
    return data.user;
  };

  const logout = async () => {
    // Server-side logout is best-effort — the client-side session must always
    // clear even if the network request fails (e.g. offline).
    try {
      await api.post("/auth/logout");
    } catch (err) {
      devWarn("[auth] /auth/logout call failed (clearing local session anyway)", err);
    }
    setUser(null);
  };

  const value = useMemo(
    () => ({ user, setUser, login, register, logout, loading }),
    [user, loading]
  );

  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);
